<template>
  <div
    ref="thediv"
    class="w-full h-full absolute overflow-hidden"
    @mousemove="clearFdAd"
    @mouseout="starFdAd"
    :style="{
      left: `${xPos}px`,
      top: `${yPos}px`,
    }"
    v-if="visible"
  >
    <span
      class="iconfont icon-line-close absolute right-5px top-5px z-1 text-12px cursor-pointer text-hex-333"
      @click="visible = false"
      v-if="showClose"
    ></span>
    <div class="w-full h-full" :class="data.layout === 'horizontal' ? 'flex' : ''">
      <slot name="content">
        <div
          class="w-full mx-0"
          :class="filterHeight()"
          v-for="(item, index) in hrefList"
          :key="index"
        >
          <el-image
            :src="`${fileUrl}${item.imageFile}`"
            :fit="data.imageFit || 'fill'"
            class="w-full h-full"
            @click="hrefTo(item)"
          ></el-image>
        </div>
      </slot>
    </div>
  </div>
</template>

<script>
import { ColumnTableApi, ColumApi } from '@wiz-api/workbench-std'
import addRequestQueue from '@/assets/js/RequestQueue'

const columnTableApi = new ColumnTableApi()
const columApi = new ColumApi()
export default {
  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      },
    },
    mode: {
      type: String,
      default: '',
    },
  },
  computed: {
    fileUrl() {
      const fileServer = Wiz.GetModuleServer('file-management')
      return `${fileServer}/api/file-management/files/public/image/`
    },
    showClose() {
      return this.data?.showClose
    },
    routerBase() {
      if (window.__POWERED_BY_QIANKUN__) {
        return `/${_.get(Wiz, 'globalSettings.globalConfig.routerBase')}`
      }
      return ''
    },
  },
  watch: {
    data: {
      immediate: true,
      deep: true,
      handler(val, oldVal) {
        if (!_.isEmpty(val) && !_.isEmpty(val.dataSource)) {
          if (
            val.dataSource &&
            (val.dataSource !== oldVal?.dataSource || val.pageSize !== oldVal?.pageSize)
          ) {
            this.getTableData(val.dataSource, val.pageSize)
          }
          this.mode === 'update' ? (this.step = 0) : (this.step = val.speed)
          this.$nextTick(() => {
            this.init()
            this.starFdAd()
          })
        }
      },
    },
  },
  data() {
    return {
      // 定义相关参数
      xPos: 0, // 初始化x轴位置
      yPos: 0, // 初始化y轴位置
      xin: true,
      yin: true,
      step: 0, // 移动速度
      delay: 18, // 刷新时间
      hOffset: 0,
      wOffset: 0,
      topPosMax: 0,
      topPosMin: 0,
      yon: true,
      xon: true,
      pause: true,
      interval: null,
      hrefList: [],
      visible: true,
    }
  },
  mounted() {
    // init()
  },
  deactivated() {
    if (this.interval) {
      window.clearInterval(this.interval)
    }
    const homePage = document.getElementsByClassName('portal-container')[0]
    if (homePage) {
      homePage.removeEventListener('scroll', this.onScroll)
    }
  },
  beforeDestroy() {
    if (this.interval) {
      window.clearInterval(this.interval)
    }
    const homePage = document.getElementsByClassName('portal-container')[0]
    if (homePage) {
      homePage.removeEventListener('scroll', this.onScroll)
    }
  },
  methods: {
    init() {
      try {
        if (this.$refs.thediv) {
          const clientRect = this.$refs.thediv.parentElement.getBoundingClientRect()
          this.hOffset = clientRect.y
          this.wOffset = clientRect.x
          const homePage = document.getElementsByClassName('homepage-index')[0]
          if (homePage) {
            if (clientRect.y + clientRect.height > window.innerHeight) return
            homePage.addEventListener('scroll', this.onScroll)
          }
        }
      } catch (error) {
        setTimeout(() => {
          this.init()
        }, 500)
      }
    },
    onScroll(e) {
      if (this.step === 0) {
        this.xPos = e.target.scrollLeft
        this.yPos = e.target.scrollTop
      }
    },
    changePos() {
      if (!this.$refs.thediv) return
      // 初始获取偏移值可能不准确，需根据判断重新获取
      const parentClientRect = this.$refs.thediv.parentElement.getBoundingClientRect()
      const scrollContainer = document.getElementsByClassName('portal-container')[0]
      if (parentClientRect.x !== this.wOffset || parentClientRect.y !== this.hOffset) {
        this.hOffset = parentClientRect.y + scrollContainer.scrollTop
        this.wOffset = parentClientRect.x + scrollContainer.scrollLeft
      }
      const clientRect = this.$refs.thediv.getBoundingClientRect()
      // 元素top最小值 = 元素距离页面顶部的距离 + 页面纵向滚动的距离
      const topPosMin = -this.hOffset + scrollContainer.scrollTop
      // 元素top最大值 = 页面可视区域高度 - 元素高度 - 元素距离页面顶部的距离 + 页面纵向滚动的距离
      const topPosMax =
        document.documentElement.clientHeight -
        clientRect.height -
        this.hOffset +
        scrollContainer.scrollTop
      // 元素left最小值 = 元素距离页面左侧的距离 + 页面横向滚动的距离
      const leftPosMin = -this.wOffset + scrollContainer.scrollLeft
      // 元素left最大值 = 页面可视区域宽度 - 元素宽度 - 元素距离页面顶部的距离 + 页面横向滚动的距离
      const leftPosMax =
        document.documentElement.clientWidth -
        clientRect.width -
        this.wOffset +
        scrollContainer.scrollLeft
      if (this.yon) {
        const nextPosY = this.yPos + this.step
        if (nextPosY > topPosMax) {
          this.yPos = topPosMax
          this.yon = false
        } else {
          this.yPos = nextPosY
        }
      } else {
        const nextPosY = this.yPos - this.step
        if (nextPosY < topPosMin) {
          this.yPos = topPosMin
          this.yon = true
        } else {
          this.yPos = nextPosY
        }
      }
      if (this.xon) {
        const nextPosX = this.xPos + this.step
        if (nextPosX > leftPosMax) {
          this.xPos = leftPosMax
          this.xon = false
        } else {
          this.xPos = nextPosX
        }
      } else {
        const nextPosX = this.xPos - this.step
        if (nextPosX < leftPosMin) {
          this.xPos = leftPosMin
          this.xon = true
        } else {
          this.xPos = nextPosX
        }
      }
    },
    clearFdAd() {
      if (this.interval) {
        window.clearInterval(this.interval)
        this.interval = null
      }
    },
    starFdAd() {
      if (!this.interval && this.step) {
        this.interval = window.setInterval(this.changePos, this.delay)
      }
    },
    async hrefTo(row) {
      if (this.mode === 'update') {
        return
      }
      if (row.jumpType === 2) {
        row.skipMode === 1 ? window.open(row.url) : (window.location.href = row.url)
      } else if (row.jumpType === 1) {
        const path = `${this.routerBase}/integration/portal/homepage?columnId=${row.jumpColumn}`
        // row.skipMode === 1
        //   ? window.open(`${window.location.origin}${window.location.hash ? '/#' : ''}${path}`)
        //   : this.$router.push(path)
        window.open(`${window.location.origin}${window.location.hash ? '/#' : ''}${path}`)
      }
    },
    async getTableData(id, pageSize) {
      const param = {
        columnId: id,
        isShow: true,
      }
      const [err, res] = await addRequestQueue(() => {
        return columnTableApi.getBinnerColumnTable(1, pageSize, param)
      })
      if (!err && res) {
        this.hrefList = []
        _.map(res.items, (it) => {
          it.isShow === true ? this.hrefList.push(it) : ''
        })
      }
    },
    filterHeight() {
      let str = ''
      if (this.data.layout === 'vertical') {
        this.hrefList.length > 1 ? (str = `h-1/${this.hrefList.length}`) : (str = 'h-full')
      } else {
        str = 'h-full'
      }
      return str
    },
  },
}
</script>

<style lang="scss" scoped></style>
